import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-payment-redirect',
  templateUrl: './payment-redirect.component.html',
  styleUrls: ['./payment-redirect.component.scss']
})
export class PaymentRedirectComponent implements OnInit {

  status = '';
  transactionId = '';
  displayStatus: 'success' | 'pending' | 'cancelled' | 'error' = 'success';

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.status = params['status'] || params['collection_status'] || '';
      this.transactionId = params['trid'] || params['external_reference'] || '';
      
      // Determine display status based on payment status
      if (this.status === 'approved') {
        this.displayStatus = 'success';
      } else if (this.status === 'pending' || this.status === 'in_process') {
        this.displayStatus = 'pending';
      } else if (this.status === 'null' || !this.status || this.status === 'rejected') {
        // User cancelled or payment failed
        this.displayStatus = 'cancelled';
      } else {
        this.displayStatus = 'error';
      }
      
      // Initialize feather icons
      setTimeout(() => {
        if (typeof (window as any).feather !== 'undefined') {
          (window as any).feather.replace();
        }
      }, 100);
      
      // Close the window after a short delay
      setTimeout(() => {
        window.close();
        
        // If window.close() doesn't work (some browsers block it), show fallback message
        setTimeout(() => {
          // This code runs if window is still open
          if (!window.closed) {
            document.body.innerHTML = '<div style="text-align: center; padding: 40px; font-family: sans-serif;"><h2>Puedes cerrar esta ventana</h2><p>Vuelve a la ventana anterior para continuar.</p></div>';
          }
        }, 100);
      }, 2500);
    });
  }
}
